export const IDLE_TIMEOUT = 10 * 60 * 1000; //in millisec
export const RESET_INTERVAL_S = 5 * 60; //in seconds 
export const CHARACTER_LIMIT=800;
export const URL_PATH = {
    "Opal":"Opal", 
    "NSW TrainLink":"NSWTrainLink",
    "Transport": "Transport",
    "TMC":"TMC"
};
export const DECODE_URL_PATH = {
    "Opal":"Opal", 
    "NSWTrainLink":"NSW TrainLink",
    "Transport": "Transport",
    "TMC":"TMC"
};
export const GROUP_TYPES = {
    OPAL: 'Opal',
    TRAIN_LINK: 'NSW TrainLink',
    TRANSPORT: 'Transport',
    TMC: 'TMC'
}
export const ACTION_TYPES = {
    NEW: 'New',
    EDIT: 'Edit'
}
export const ENVIRONMENT_tYPE = {
    LIVE: 'Live',
    STAGING: 'Staging'
}

export const ANNOUNCEMENT_TYPES = {
    Opal: [{
        announcementType: '131500AvalancheOpal',
        message: "",
        environment: 'All',
        lastModifiedDateTime: '',
        lastModifiedUserName: '',
        description: 'Opal Avalanche announcement for 131 500'
    }
    ],
    Transport: [{
        announcementType: '131500AvalancheMain',
        message: "",
        environment: 'All',
        lastModifiedDateTime: '',
        lastModifiedUserName: '',
        description: 'Main Transport Avalanche announcement for 131 500'
    }],
    TrainLink: [{
        announcementType: '132232AvalancheMain',
        message: "",
        environment: 'All',
        lastModifiedDateTime: '',
        lastModifiedUserName: '',
        description: 'Main Trains Avalanche announcement for 132 232'
    },
    {
        announcementType: '132232AvalancheBH',
        message: "",
        environment: 'All',
        lastModifiedDateTime: '',
        lastModifiedUserName: '',
        description: 'Trains Business Hours Avalanche announcement for 132 232'
    },
    {
        announcementType: '132232AvalancheAH',
        message: "",
        environment: 'All',
        lastModifiedDateTime: '',
        lastModifiedUserName: '',
        description: 'Trains After Hours Avalanche announcement for 132 232'
    },
    {
        announcementType: '132242AvalancheMain',
        message: "",
        environment: 'All',
        lastModifiedDateTime: '',
        lastModifiedUserName: '',
        description: 'Main Trains Avalanche announcement for 132 242'
    }],
    TMC: [{
        announcementType: '131500AvalancheTMC',
        message: "",
        environment: 'All',
        lastModifiedDateTime: '',
        lastModifiedUserName: '',
        description: 'TMC Avalanche announcement for 131 500'
    },
    {
        announcementType: '131700AvalancheTMC',
        message: "",
        environment: 'All',
        lastModifiedDateTime: '',
        lastModifiedUserName: '',
        description: 'TMC Avalanche announcement for 131 700'
    }]
}

export const LIVE_MODALMESSAGE = "You have made changes to the following announcement. Would you like to submit these changes to Live?";

export const STAGING_MODALMESSAGE = "You have made changes to the following announcement. Would you like to submit these changes to Staging?";

export const LIVE_DELETE_MESSAGE = "Are you sure you would like to delete the following announcement from Live ?";

export const STAGING_DELETE_MESSAGE = "Are you sure you would like to delete the following announcement from Staging ?";

export const DELETE_SP_EVENT_MESSAGE ="Do you want to Delete special event ?";

